/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfacePollOption } from './SurfacePollOption';
import {
    SurfacePollOptionFromJSON,
    SurfacePollOptionFromJSONTyped,
    SurfacePollOptionToJSON,
    SurfacePollOptionToJSONTyped,
} from './SurfacePollOption';

/**
 * 
 * @export
 * @interface SurfacePollConfig
 */
export interface SurfacePollConfig {
    /**
     * 
     * @type {string}
     * @memberof SurfacePollConfig
     */
    question?: string;
    /**
     * 
     * @type {Array<SurfacePollOption>}
     * @memberof SurfacePollConfig
     */
    options?: Array<SurfacePollOption>;
    /**
     * 
     * @type {boolean}
     * @memberof SurfacePollConfig
     */
    allowMultiple?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfacePollConfig
     */
    showResults?: boolean;
}

/**
 * Check if a given object implements the SurfacePollConfig interface.
 */
export function instanceOfSurfacePollConfig(value: object): value is SurfacePollConfig {
    return true;
}

export function SurfacePollConfigFromJSON(json: any): SurfacePollConfig {
    return SurfacePollConfigFromJSONTyped(json, false);
}

export function SurfacePollConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfacePollConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'question': json['question'] == null ? undefined : json['question'],
        'options': json['options'] == null ? undefined : ((json['options'] as Array<any>).map(SurfacePollOptionFromJSON)),
        'allowMultiple': json['allowMultiple'] == null ? undefined : json['allowMultiple'],
        'showResults': json['showResults'] == null ? undefined : json['showResults'],
    };
}

export function SurfacePollConfigToJSON(json: any): SurfacePollConfig {
    return SurfacePollConfigToJSONTyped(json, false);
}

export function SurfacePollConfigToJSONTyped(value?: SurfacePollConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question': value['question'],
        'options': value['options'] == null ? undefined : ((value['options'] as Array<any>).map(SurfacePollOptionToJSON)),
        'allowMultiple': value['allowMultiple'],
        'showResults': value['showResults'],
    };
}

